<template>
  <div class="wrapper">
    <div class="header"><img src="../assets/img/chekt-logo.png" style="width:100px;height:100%;"></div>
      <transition name="component-fade" mode="out-in">
        <!-- signup -->
        <div v-if="!signupSuccess" class="signup" v-bind:class="{failed:isSignupFailed}">
          <div class="form">
            <div class="form-header">
              <div class="title">
                <div>Sign up your accuont</div>
              </div>
            </div>
            <div class="email">Email</div>
            <div class="input" style="margin-bottom:30px;">
              <input v-model="email" v-on:keyup.enter="clickSignup(email, password)" autofocus id="email" type="email" placeholder="yours@chekt.com">
            </div>
            <div class="passwords">
              <div class="password">Password</div>
            </div>
            <div class="input" style="margin-bottom:20px;">
              <input v-model="password" v-on:keyup.enter="clickSignup(email, password)" type="password" placeholder="your password" id="password">
            </div>
            <div class="passwords">
              <div class="password">Confirm Password</div>
            </div>
            <div class="input">
              <input v-model="confirmPassword" v-on:keyup.enter="clickSignup(email, password)" type="password" placeholder="confirn your password" id="passwordConfirm">
            </div>
            <div v-if="isSignupFailed" class="failed-text" style="margin-top:20px;">
              <CompIcon style="color:#CD3D64;" v-bind:icon="'error'" v-bind:width="18" />
              <div style="margin-left:5px; text-align:left;">{{loginFailMessage}}</div>
            </div>
            <div v-on:click="clickSignup(email, password)" v-bind:class="{loading:isLoading}" class="signup-btn" style="margin-bottom:20px; margin-top:50px;">
              <div v-if="isLoading" class="loader"></div>
              <div v-else>Sign up</div>
            </div>
            <div class="passwordless">Can't sign up? <span v-on:click="clickPasswordless()" class="try-resend-signup">Try resend sign up email</span></div>

          </div>
        </div>
        
        <!-- signup success -->
        <div v-else class="signup" v-bind:class="{failed:isSignupFailed}">
          <div class="form">
            <div class="form-header">
              <div class="title">
                <div>🎉 Successfully signed up!</div>
              </div>
            </div>

            <div>
              <div class="signedup-subtitle">You can use the chekt app now.</div>
              <div class="signedup-desc">Please download the app in appstore or playstore with your phone. You can login the app with your signed up email and password.</div>
            </div>

            <div class="download-apps">
              <div @click="goToLink('ios')" class="download-app"> Download for IOS </div>
              <div @click="goToLink('android')" class="download-app"> Download for Android </div>
            </div>

          </div>
        </div>
      </transition>
    <div class="footer">
      <span @click="goToLink('chekt')" class="footer-item">© CHeKT</span>
      <span> · </span> 
      <span @click="goToLink('contact')" class="footer-item">Contact</span>
      <span> · </span> 
      <span @click="goToLink('privacy')" class="footer-item">Privacy & terms</span>
    </div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  components: {
    CompIcon
  },
  name: 'signup',
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      loginFailMessage: '',
      isLoading: false,
      isEmailExist: false,
      isSignupFailed: false,
      passowordMatch: false,
      isInvailedEmail: false,
      signupSuccess: false,
    }
  },
  watch: {
    password: function () {
      this.checkPasswordMacth()
    },
    confirmPassword: function () {
      this.checkPasswordMacth()
    },
    email: function () {
      if (!this.$tool.isValidEmailAddress(this.email)) this.isInvailedEmail = true
      else this.isInvailedEmail = false
    }
  },
  computed: {
  },
  created: function () {
  },
  methods: {
    checkPasswordMacth: function () {
      if (this.password === this.confirmPassword) this.passowordMatch = true
      else this.passowordMatch = false
    },
    clickSignup: async function (email, password) {
      var passwordDom = document.getElementById('password')
      var passwordConfirmDom = document.getElementById('passwordConfirm')
      var emailDom = document.getElementById('email')
      passwordDom.blur()
      passwordConfirmDom.blur()
      emailDom.blur()
      passwordDom.disabled = true
      passwordConfirmDom.disabled = true
      emailDom.disabled = true
      this.isSignupFailed = false
      this.isLoading = true
      await this.$tool.wait(500) // Too fast

      if (!this.checkInput(emailDom, passwordDom, passwordConfirmDom)) return

      // LOGIN ACTION!!!!
      try {
        // CASE 1 - Sign IN successful
        await this.$firebase.auth.signIn({email, password})
        this.signupSuccess = true
      } catch (err) {
        this.isSignupFailed = true
        this.loginFailMessage = err.message
      }
      this.isLoading = false
      passwordDom.disabled = false
      emailDom.disabled = false
      passwordConfirmDom.disabled = false
    },
    checkInput: function (emailDom, passwordDom, passwordConfirmDom) {

      const failedRoutine = () => {
        this.isSignupFailed = true
        this.isLoading = false
        emailDom.disabled = false
        passwordDom.disabled = false
        passwordConfirmDom.disabled = false
      }

      // 1. when enpty email or password
      if (!this.password || !this.confirmPassword || !this.email) {
        failedRoutine()
        this.loginFailMessage = 'Please set your email or password'
        return false
      }

      // 2. check valid email
      if (this.isInvailedEmail) {
        failedRoutine()
        this.loginFailMessage = 'Invalid email format'
        return false
      }

      // 3. check password match
      if (!this.passowordMatch) {
        failedRoutine()
        this.loginFailMessage = 'No matched password with confirm password'
        return false
      }

      return true
    },
    goToLink (type) {
      let link = null

      if (type === 'ios') link = 'https://apps.apple.com/app/chekt-com/id1508918518?l=en-GB'
      else if (type === 'android') link = 'https://play.google.com/store/apps/details?id=com.chekt.app.v3'
      else if (type === 'chekt') link = 'https://chekt.com/'
      else if (type === 'contact') link = 'https://chekt.com/dealers/contact/'
      else if (type === 'privacy') link = 'https://chekt.com/privacy-policy/'

      if (link) window.open(link, "_blank")
    }
  }
}
</script>

<style scoped>

.wrapper {
  margin: auto;
  margin-top: 60px;
  padding-bottom: 60px;
  width: 540px;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: 50px;
  margin-left: 30px;
  display: flex;
  justify-content: flex-end;
}
.footer {
  font-size: 12px;
  color: var(--blue-gray-high);
  text-align: center;
  margin-top: 30px;
}
.footer-item {
  cursor: pointer;
}
.footer-item:hover {
  color: var(--gray-high);
}


/****** animations ******/

.component-fade-enter-active, .component-fade-leave-active {
  transition: all .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-200px);
}

.signup {
  box-shadow: 0px 0px 20px 0px #e3e8ee6d;
  border: solid 1px var(--blue-gray-medium);
  border-radius: 5px;
}
.signup.failed {
  /****** animation ******/
  animation: shake .6s linear;
}
.form {
  margin: 60px 60px 100px 60px;
}
.form-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items:center;
  position: relative;
  margin-bottom: 30px;
}
.avatar {
  position: absolute;
  display: block;
  align-self: center;
  width: 110px;
  height: 110px;
  background-color: rgb(140, 70, 70);
  box-shadow: 0px 0px 20px 0px #e3e8ee6d;
  border: solid 1px var(--blue-gray-medium);
  border-radius: 50%;
  right: 0px;
  top: -80px;
  object-fit: cover;
  /****** animation ******/
  animation: fade .4s linear;
}
.title {
  font-size: 24px;
  font-weight: 600;
  color: var(--gray-high);
  text-align: start;
}
.email {
  font-size: 14px;
  color: var(--gray-high);
  text-align: start;
  margin-bottom: 10px;
}
.passwords {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.password {
  font-size: 14px;
  color: var(--gray-high);
}
.password-eye {
  position: relative;
}
.forgot-password {
  font-size: 13px;
  color: var(--primary);
  cursor: pointer;
}
.forgot-password:hover {
  color: var(--gray-high);
}
.failed-text {
  font-size: 14px;
  color: var(--danger);
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: start;
  transition:all .5s;
  transition-delay: 1s;
  align-items: center;
}
.input input {
  width: calc(100% - 20px);
  font-size: 16px;
  border: solid 1px#E6E6E6;
  padding: 10px;
  border-radius: 5px;
  /****** animation ******/
  transition:box-shadow .3s;
}
.input input::placeholder {
  color: var(--gray-low);
}
input:focus {
  outline: none; 
  box-shadow: 0 0 0 3px #AAD2F5;
}
.signup-btn {
  color: white;
  padding-top: 13px;
  padding-bottom: 13px;
  background-color: var(--primary);
  border-radius: 5px;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
}
.signup-btn.loading{
  background-color: rgb(31, 137, 229, 60%);
  pointer-events: none;
}
.passwordless {
  font-size: 12px;
  color: var(--blue-gray-high);
  text-align: center;
}
.try-resend-signup {
  color: var(--primary);
  cursor: pointer;
  font-weight: 400;

}
.try-resend-signup:hover {
  color: var(--gray-high);
}
.loader {
  border: 2px solid #ffffff;
  border-top: 2px solid #ffffff00;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  /****** animation ******/
  animation: spin 1s linear infinite;
  margin: auto;
}

.signedup-subtitle {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.signedup-desc {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 50px;
  color: var(--gray-medium);
  line-height: 18px;
}
.download-apps {
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-high);
  line-height: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.download-app {
  text-align: center;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(0 0 0/12%) 0px 1px 1px 0px,rgb(64 68 82/16%) 0px 0px 0px 1px,rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(64 68 82/8%) 0px 2px 5px 0px;
}
.download-app:hover {
  transition: background-color .3s,box-shadow .3s;
  box-shadow: rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(0 0 0/12%) 0px 1px 1px 0px,rgb(64 68 82/16%) 0px 0px 0px 1px,rgb(0 0 0/0%) 0px 0px 0px 0px,rgb(64 68 82/8%) 0px 3px 9px 0px,rgb(64 68 82/8%) 0px 2px 5px 0px;
}

/****** animations ******/

@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg); }
}
@keyframes fade {
  0% { opacity: 0; transform: translate3d(0px, -50px, 0px); }
  100% { opacity: 100; transform: translate3d(0); }
}
@keyframes shake {
  0% { transform: translate(40px); }
  20% { transform: translate(-40px); }
  40% { transform: translate(20px); }
  60% { transform: translate(-20px); }
  80% { transform: translate(10px); }
  100% { transform: translate(0px); }
}

/****** media ******/
@media screen and (max-width: 600px) {
  .header {
    margin-bottom: 25px;
    margin-left: 15px;
  }
  .avatar {
    display: none;
  }
  .form {
    margin: 60px 30px 100px 30px;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg); }
}
@keyframes fade {
  0% { opacity: 0; transform: translate3d(0px, -50px, 0px); }
  100% { opacity: 100; transform: translate3d(0); }
}
@keyframes shake {
  0% { transform: translate(40px); }
  20% { transform: translate(-40px); }
  40% { transform: translate(20px); }
  60% { transform: translate(-20px); }
  80% { transform: translate(10px); }
  100% { transform: translate(0px); }
}

/****** media ******/
@media screen and (max-width: 600px) {
  .wrapper {
    width: calc(100% - 40px);
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .header {
    margin-bottom: 25px;
    justify-content: center;
  }
}
@media screen and (max-width: 380px) {
  .wrapper {
    min-width: 280px;
    width: calc(100% - 40px);
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/Signup.vue